const DISPLAY_NAME_MAP = {
  statusOutOfDate: 'Needs Progress Update',
  hasNewChanges: 'New Referral Information',
  onlyOtherOrganizations: 'Only Patients Followed by Other Organizations',
  removedFromCensus: 'Patients Ready to Discharge',
  needsDischargeReview: 'Discharges Needing Review',
  showArchived: 'Show Archived Referrals',
};

export default class FilterValueBoolean {
  name: string;
  value: boolean;

  constructor(value = { name: '', value: false }) {
    this.name = value.name;
    this.value = value.value;
  }

  get label() {
    return DISPLAY_NAME_MAP[this.name] || this.name;
  }

  removeFilter() {
    return new FilterValueBoolean({ ...this, value: false });
  }

  serialize() {
    return this.value;
  }
}
